import { API } from "shared/services";

export async function loadTags() {
  const { data } = await API.get("/customer_tags");
  return data;
}

export function createNewTag(newTagName) {
  return API.post("/customer_tags", { name: newTagName });
}

export function toggleTagVisibility(status, id) {
  return API.put(`/customer_tags/${id}`, {
    visible: !status,
  });
}

export function editTagName(id, newTagName) {
  return API.put(`/customer_tags/${id}`, { name: newTagName });
}

export function deleteTag(tagId) {
  return API.delete(`/customer_tags/${tagId}`);
}
